<template>
  <div class="extension-callback">
    <div class="callback-card">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h1>Sign In Successful!</h1>
      <p>You've been signed in to the ResyMaid Chrome extension.</p>
      <p class="hint">This tab should close automatically. If it doesn't, you can close it now.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExtensionCallback",
};
</script>

<style scoped>
.extension-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%);
  padding: 20px;
}

.callback-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 48px;
  text-align: center;
  max-width: 400px;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.success-icon i {
  font-size: 40px;
  color: #ffffff;
}

h1 {
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px;
}

p {
  color: #a1a1aa;
  font-size: 16px;
  margin: 0 0 8px;
  line-height: 1.5;
}

.hint {
  font-size: 14px;
  color: #71717a;
  margin-top: 20px;
}
</style>
